import React from 'react';
import { Redirect } from '@reach/router';

import AuthContext from '#components/AuthContext';

interface Props {
    authMode: string;
}

interface AuthContextProps {
    isAuthenticated: boolean | undefined;
}

const withAuth = (WrappedComponent: React.ComponentType<Props>) => ((props: Props) => (
    <AuthContext.Consumer>
        {(value: AuthContextProps | undefined) => {
            if (props.authMode === 'private' && value.isAuthenticated === false) {
                return (
                    <Redirect
                        to="/login/"
                        noThrow
                    />
                );
            }

            if (props.authMode === 'exclusivelyPublic' && value.isAuthenticated === true) {
                return (
                    <Redirect
                        to="/"
                        noThrow
                    />
                );
            }

            return <WrappedComponent {...props} />;
        }}
    </AuthContext.Consumer>
));

export default withAuth;
